// Test IDs for the Configuración de la clínica feature.

export const CLINIC = {
        nameInput: 'clinic-name-input',
        addressInput: 'clinic-address-input',
        phoneInput: 'clinic-phone-input',
        emailInput: 'clinic-email-input',
        timezoneSelect: 'clinic-timezone-select',
        languageCheckboxPrefix: 'clinic-language-checkbox-',
        primaryColorInput: 'clinic-primary-color-input',
        secondaryColorInput: 'clinic-secondary-color-input',
        logoUpload: 'clinic-logo-upload',
        saveButton: 'clinic-save-button',

        // Página pública de reservas (URL/slug, QR, redes sociales)
        slugInput: 'clinic-slug-input',
        publicUrlPreview: 'clinic-public-url-preview',
        copyPublicUrlButton: 'clinic-copy-public-url-button',
        instagramInput: 'clinic-instagram-input',
        facebookInput: 'clinic-facebook-input',
        qrCanvas: 'clinic-qr-canvas',
        qrDownloadButton: 'clinic-qr-download-button',
        publicBookingSaveButton: 'clinic-public-booking-save-button',

        // Pago en la reserva publica
        publicPaymentModeSelect: 'clinic-public-payment-mode-select',
        publicDepositTypeSelect: 'clinic-public-deposit-type-select',
        publicDepositValueInput: 'clinic-public-deposit-value-input',
        publicPaymentSaveButton: 'clinic-public-payment-save-button',

        // Boton de ayuda por WhatsApp en la reserva publica
        whatsappHelpToggle: 'clinic-whatsapp-help-toggle',
        whatsappHelpNumberInput: 'clinic-whatsapp-help-number-input',
        whatsappHelpMessageInput: 'clinic-whatsapp-help-message-input',
        whatsappHelpSaveButton: 'clinic-whatsapp-help-save-button',

        // Campos obligatorios de pacientes
        requiredFieldCheckboxPrefix: 'clinic-required-field-checkbox-',
        requiredFieldsSaveButton: 'clinic-required-fields-save-button',

        // Mensaje de seguimiento por WhatsApp
        followupTemplateInput: 'clinic-followup-template-input',
        followupTemplateSaveButton: 'clinic-followup-template-save-button',

        // Numero de WhatsApp institucional
        whatsappNumberInput: 'clinic-whatsapp-number-input',

        // Horarios de atencion (estructurados, a nivel clinica)
        businessHoursCard: 'clinic-business-hours-card',
        businessHoursDayPrefix: 'clinic-business-hours-day-', // + dayIndex
        businessHoursSaveButton: 'clinic-business-hours-save-button',

        // Medios de pago aceptados (visibles en la reserva publica)
        paymentMethodsCard: 'clinic-payment-methods-card',
        paymentMethodCheckboxPrefix: 'clinic-payment-method-checkbox-', // + method
        paymentMethodsSaveButton: 'clinic-payment-methods-save-button',

        // Financiamiento (ej. Cherry) - informativo, sin integracion por API
        financingCard: 'clinic-financing-card',
        financingToggle: 'clinic-financing-toggle',
        financingProviderInput: 'clinic-financing-provider-input',
        financingUrlInput: 'clinic-financing-url-input',
        financingNoteInput: 'clinic-financing-note-input',
        financingSaveButton: 'clinic-financing-save-button',

        // Fix P (2026-09-30): WhatsApp oficial (Meta)
        whatsappMetaCard: 'clinic-whatsapp-meta-card',
        whatsappMetaRefresh: 'clinic-whatsapp-meta-refresh',
        whatsappMetaProvider: 'clinic-whatsapp-meta-provider',
        whatsappMetaStatus: 'clinic-whatsapp-meta-status',
        whatsappMetaSubscribed: 'clinic-whatsapp-meta-subscribed',
        whatsappMetaSubscribeButton: 'clinic-whatsapp-meta-subscribe-button',
        whatsappMetaConnect: 'clinic-whatsapp-meta-connect',
        whatsappMetaCodeSms: 'clinic-whatsapp-meta-code-sms',
        whatsappMetaCodeVoice: 'clinic-whatsapp-meta-code-voice',
        whatsappMetaCodeInput: 'clinic-whatsapp-meta-code-input',
        whatsappMetaVerifyButton: 'clinic-whatsapp-meta-verify-button',
        whatsappMetaPinInput: 'clinic-whatsapp-meta-pin-input',
        whatsappMetaRegisterButton: 'clinic-whatsapp-meta-register-button',
};
